import { render, staticRenderFns } from "./TwoFactorsAuthV2.vue?vue&type=template&id=88e34f38&scoped=true"
import script from "./TwoFactorsAuthV2.vue?vue&type=script&lang=js"
export * from "./TwoFactorsAuthV2.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorsAuthV2.vue?vue&type=style&index=0&id=88e34f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e34f38",
  null
  
)

export default component.exports